import React, { useState, useEffect } from 'react';

const Pipes = () => {

  const canvasStyle = {
    // zIndex: '1',
    // // position: 'absolute',
    // // top: 0,
    // // left: 0,
    // width: 400,
    // height: 400,
  };

  useEffect(() => {

    const canvas = document.getElementById('canvas') // sets up our canvas a bit
      const ctx = canvas.getContext('2d');
      canvas.width = 200;
      canvas.height = 200;
      ctx.fillStyle = "black";
      // ctx.fillRect(0, 0, canvas.width, canvas.height);
      // let t0 = new Date().getTime();
      let grow = true
      // (function () {
          var centerx = ctx.canvas.width / 2;
          var centery = ctx.canvas.height / 2;
          let a=.1
          let b=.1
          let count = 1;
          let x=centerx
          let y=centery

          let boop = .1
          let bop = 500
          setInterval(() => {
            if (grow == true) {
              bop += 1;
            } else {
              bop -= 1;
            }
            if (bop >= 1000) {
              grow = false
            }

            if (bop <= 800) {
              grow = true
            }

            ctx.beginPath();
            ctx.arc(centerx, centery, 80, 0, 2 * Math.PI, false);
            ctx.fillStyle = 'black';
            ctx.fill();
            ctx.stroke();
            ctx.closePath();

            // ctx.fillRect(0, 0, canvas.width, canvas.height);
            for (let r = 1; r <= 255; r+=8) {

              
              for (let g = 88; g <= 255; g+=8) {

                
                for (let b = 1; b <= 3; b+=8) {
                  
         

                  ctx.beginPath();
                  ctx.moveTo(x, y);
                  
                  let angle = (boop*bop) * count;
                  
                  x = centerx + (a + b * angle) * Math.cos(angle);
                  y = centery + (a + b * angle) * Math.sin(2^-2 * angle);
                  
                  ctx.lineTo(x, y);
                  
                  ctx.strokeStyle = `RGB(${r},${g},200)` 
                  ctx.stroke();
                  ctx.closePath()
                
                  
                  if (count > -50) {
                    count -= .001;
                  } else {
                    count += .001;
                  }
                
                  if (count < .73) count = 1
                  // if (count < .7) count = 10
                  // if (count < .74) count = 1
                  // console.log(count)
                }
              }
            }
   
            // console.log(count);
          }, 100);

      // })();
  }, []);
    // let t1 = new Date().getTime();
    // console.log(t1-t0)

  return (
    <div>
         <canvas id="canvas" style={canvasStyle}></canvas>
    </div>
  );
};

export default Pipes;